import { render } from "./editOrganization.vue?vue&type=template&id=fc758400&scoped=true"
import script from "./editOrganization.vue?vue&type=script&lang=js"
export * from "./editOrganization.vue?vue&type=script&lang=js"

import "./editOrganization.vue?vue&type=style&index=0&id=fc758400&scoped=true&lang=css"

import exportComponent from "/home/stagging/consillium/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc758400"]])

export default __exports__